import IOrder from "@models/IOrder";
import IOrder_Progress_State from "@models/IOrder_Progress_State";
import OwButton from "@components/shared/OwButton/OwButton";
import { useContext, useState } from "react";
import SupplierContext from "@contexts/SupplierContext";
import "./OrderPaymentAuthorizeNet.scss";
import { OrderPaymentAuthorizeNetReview } from "./OrderPaymentAuthorizeNetReview/OrderPaymentAuthorizeNetReview";
import { OrderPaymentAuthorizeNetCompleted } from "./OrderPaymentAuthorizeNetCompleted/OrderPaymentAuthorizeNetCompleted";
import { OrderPaymentAuthorizeNetPaymentSelection } from "./OrderPaymentAuthorizeNetPaymentSelection/OrderPaymentAuthorizeNetPaymentSelection";
import { AuthorizeNetContext } from "@contexts/AuthorizeNetContext";
type Props = {
    orderModel: IOrder;
    cancelFn: (refresh?: boolean) => void;
    confirmFn: (refresh?: boolean) => void;
    nextStep?: IOrder_Progress_State;
};

export const OrderPaymentAuthorizeNet = (props: Props) => {
    const supplierModel = useContext(SupplierContext);

    const [slide, setSlide] = useState(0);
    const [existingCard, setExistingCard] = useState<any>(null);
    const [newPaymentDetails, setNewPaymentDetails] = useState<any>(null);
    const [isLoading, setIsLoading] = useState(false);
    const [processingCompleted, setProcessingCompleted] = useState(false);

    const nextSlide = () => {
        if (slide < 2) {
            // Only go to slide 2 max (since we have 3 slides)
            setSlide(slide + 1);
        }
    };

    const prevSlide = () => {
        if (slide > 0) {
            // Only go to slide 0 min
            setSlide(slide - 1);
        }
    };

    const authData = {
        apiLoginID: supplierModel.Supplier_Integration.authnet_login_id || "",
        clientKey: supplierModel.Supplier_Integration.authnet_public_client_key || "",
    };

    if (!authData.apiLoginID?.length || !authData.clientKey?.length) {
        return (
            <div>
                <div className="text-end">
                    <OwButton
                        className="btn-danger"
                        centerIconClass="fas fa-times"
                        fn={() => {
                            props.cancelFn();
                        }}
                    />
                </div>
                <div className="text-center">
                    <p>No Authorize.Net credentials found</p>
                </div>
            </div>
        );
    }

    return (
        <div className={"OrderPaymentAuthorizeNet"}>
            <AuthorizeNetContext.Provider
                value={{
                    existingCard,
                    setExistingCard,
                    newPaymentDetails,
                    setNewPaymentDetails,
                    isLoading,
                    setIsLoading,
                    nextSlide,
                    prevSlide,
                    processingCompleted,
                    setProcessingCompleted,
                }}>
                {processingCompleted ? null : (
                    <div className="text-end">
                        <OwButton
                            className="btn-danger"
                            centerIconClass="fas fa-times"
                            fn={() => {
                                props.cancelFn();
                            }}
                        />
                    </div>
                )}
                <div className={`slides-container slide-${slide}`}>
                    <div className={"payment-slide h-100"}>
                        <OrderPaymentAuthorizeNetPaymentSelection orderModel={props.orderModel} />
                    </div>

                    <div className={"payment-slide h-100"}>
                        <OrderPaymentAuthorizeNetReview orderModel={props.orderModel} />
                    </div>

                    <div className={"payment-slide h-100"}>
                        <OrderPaymentAuthorizeNetCompleted orderModel={props.orderModel} confirmFn={props.confirmFn} />
                    </div>
                </div>
            </AuthorizeNetContext.Provider>
        </div>
    );
};
